import React from "react";
import RealDashboard from "./RealDashboard";

// Simply export the RealDashboard component to replace the static one
function Dashboard() {
  return <RealDashboard />;
}

export default Dashboard;
